import { Pipe, PipeTransform } from '@angular/core';
import {Helper} from "../../utils/helper.module";


@Pipe({
  name: 'hourpipe'
})


export class HourPipe implements PipeTransform {
  transform(hour:any): any {

/*console.log( new Date(hour.substring(0,5)).getHours())*/
    return hour.substring(0,5);
  }
}
